import React from "react";
import Layout from "..";
import Herosection from "../HeroSection/Herosection";
function Home() {
  return (
    <Layout className="overflow-x-hidden">
      <Herosection />
    </Layout>
  );
}

export default Home;
